var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-toolbar',{staticClass:"mb-4",attrs:{"flat":""}},[_c('v-btn',{attrs:{"outlined":"","to":{
        name: 'FinancePersonDetail',
        params: { id: _vm.id },
        query:
          _vm.value && _vm.value.schoolClass
            ? { schoolClass: _vm.value.schoolClass.id }
            : { teachers: true },
      }}},[_vm._v("zum Konto")])],1),_c('v-card',{attrs:{"flat":"","tile":"","loading":_vm.loading}},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.itemsShown.length)+" offenen Rechnungen ")])],1),_c('TableComponent',{attrs:{"items":_vm.itemsShown,"loading":_vm.loading},on:{"showDetails":_vm.showDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }